<template>
    <Radar
        :chart-options="chartOptions"
        :chart-data="chartData"
        chart-id="competencies-radar"
        dataset-id-key="label"
        :width="400"
        :height="400"
    />
</template>

<script>
    import { Radar } from 'vue-chartjs/legacy'

    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        PointElement,
        LineElement,
        RadialLinearScale
    } from 'chart.js'

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        PointElement,
        RadialLinearScale,
        LineElement
    )

    export default {
    
        components: {
            Radar
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                competency_domains_tags: data.competency_domains_tags,

                labels: [],
                scores: [],

                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                    scales: {
                        r: {
                            suggestedMin: 0,
                            suggestedMax: 5,
                            ticks: {
                                stepSize: 1
                            },
                            grid: {
                                lineWidth: (context) => {
                                    return context.index === 2 ? 3 : 1;
                                },
                            }
                        }
                    }
                }
            }
        },

        computed: {

            endpoint() {
                return this.phase
                    ? this.app_url + 'polaris/api/front/dashboard/registrations/' + this.registration.id + '/phases/' + this.phase.id + '/learners/' + this.learner.id + '/competencies'
                    : this.app_url + 'polaris/api/front/dashboard/registrations/' + this.registration.id + '/learners/' + this.learner.id + '/competencies'
            },

            chartData() {
                return {
                    labels: this.labels,
                    datasets: [
                        {
                            label: 'Competencies',
                            backgroundColor: '#26c6da',
                            borderColor: '#26c6da',
                            pointBackgroundColor: '#26c6da',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: '#26c6da',
                            data: this.scores
                        }
                    ]
                }
            },
        },

        created() {
            axios.get(this.endpoint)
            .then(response => {
                let labels = []
                let scores = []
                for (const key of Object.keys(response.data.data)) {
                    labels.push(this.competency_domains_tags[key])
                    scores.push(response.data.data[key].avg)
                }
                this.labels = labels
                this.scores = scores
            })
        },
    }
</script>
